import React from 'react';
import { DropdownButton, MenuItem, OverlayTrigger } from 'react-bootstrap';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { accessorialPaid, accessorialProcessed, userCanApproveAccessorials as userCanApproveAccessorialsHelper, checkIfEquipmentIsMissingForAccessorial, checkWhichSideAccessorialAutoDeclined, isCarrierMissingInAccessorial, } from 'helpers/accessorials';
import { isShipmentCanceled } from 'helpers/shipments';
import SessionStore from 'stores/SessionStore';
import { TOOLTIPS } from './accessorialTooltips';
const BulkActionsMenu = ({ accessorial, shipment, isAccessorialsAdmin, isEditSaving, isApproveSaving, isDeclineSaving, onBulkAction, }) => {
    var _a, _b;
    const { t } = useTranslation();
    const isAnySaving = isEditSaving || isApproveSaving || isDeclineSaving;
    const isProcessed = accessorialProcessed(shipment, accessorial);
    const shipmentCarrier = ((_a = shipment === null || shipment === void 0 ? void 0 : shipment.carrier) === null || _a === void 0 ? void 0 : _a._id) || (shipment === null || shipment === void 0 ? void 0 : shipment.carrier);
    const carrierAssociatedWithAccessorial = ((_b = accessorial.carrier) === null || _b === void 0 ? void 0 : _b._id) || accessorial.carrier;
    const carrierMismatch = accessorial.payee_type === 'carrier' &&
        shipmentCarrier !== carrierAssociatedWithAccessorial;
    const isAlreadyApproved = accessorial.carrier_status === 'approved' &&
        accessorial.shipper_status === 'approved';
    const disableBulkApprove = carrierMismatch || isAlreadyApproved;
    const disablePayeeResolutions = disableBulkApprove;
    const isMissingDocs = !!(accessorial === null || accessorial === void 0 ? void 0 : accessorial.missing_docs) ||
        (accessorial === null || accessorial === void 0 ? void 0 : accessorial.customer_approval_provided) === false;
    const isMissingEquipment = checkIfEquipmentIsMissingForAccessorial(accessorial);
    const shipperSideDeclined = checkWhichSideAccessorialAutoDeclined(accessorial, 'shipper');
    const carrierSideDeclined = checkWhichSideAccessorialAutoDeclined(accessorial, 'carrier');
    const isCarrierMissing = isCarrierMissingInAccessorial(accessorial);
    const accessorialDeclined = shipperSideDeclined || carrierSideDeclined;
    const payableIsProcessed = accessorialPaid(shipment, accessorial);
    const canUserApprove = () => {
        if (isMissingEquipment || accessorialDeclined || isCarrierMissing) {
            return false;
        }
        const user = SessionStore.getUser();
        const canSelect = userCanApproveAccessorialsHelper(user, [accessorial]);
        if (canSelect && isAccessorialsAdmin) {
            return true;
        }
        return canSelect && !isMissingDocs;
    };
    let approveTooltipOverlay = TOOLTIPS.MISSING_DOCS;
    if (isMissingEquipment)
        approveTooltipOverlay = TOOLTIPS.MISSING_EQUIPMENT;
    if (isCarrierMissing)
        approveTooltipOverlay = TOOLTIPS.NO_CARRIER_ASSIGNED_INFO;
    if (accessorialDeclined)
        approveTooltipOverlay = TOOLTIPS.SHIPPER_CHANGED;
    const disableDeclineBtn = accessorialDeclined ||
        isCarrierMissing ||
        (carrierMismatch && payableIsProcessed);
    const declineTooltipOverlay = accessorialDeclined
        ? TOOLTIPS.SHIPPER_CHANGED
        : TOOLTIPS.NO_CARRIER_ASSIGNED_INFO;
    const style = {
        backgroundColor: 'white',
        color: '#25AA82',
        borderColor: '#25AA82',
        fontSize: '.875rem',
        fontWeight: '700',
        borderRadius: '.25rem',
    };
    const renderDropdown = (disabled) => {
        const dropdownStyle = Object.assign({}, style);
        if (disabled) {
            dropdownStyle.pointerEvents = 'none';
        }
        const effectiveDisabled = disabled || isAnySaving;
        const dropdownClass = classnames({
            button: true,
            'mr-2': true,
            'button-green': !effectiveDisabled,
        });
        return (React.createElement(DropdownButton, { disabled: effectiveDisabled, title: t('ACTIONS'), onSelect: onBulkAction, bsSize: "small", id: "acessorial-bulk-actions", style: dropdownStyle, className: dropdownClass },
            !canUserApprove() ? (React.createElement(OverlayTrigger, { placement: "left", overlay: approveTooltipOverlay },
                React.createElement(MenuItem, { eventKey: "approve-all", disabled: !canUserApprove() }, t('APPROVE_ALL')))) : (React.createElement(MenuItem, { eventKey: "approve-all", disabled: !canUserApprove() }, t('APPROVE_ALL'))),
            disableDeclineBtn ? (React.createElement(OverlayTrigger, { placement: "left", overlay: declineTooltipOverlay },
                React.createElement(MenuItem, { eventKey: "decline-all", disabled: disableDeclineBtn }, t('DECLINE_ALL')))) : (React.createElement(MenuItem, { eventKey: "decline-all" }, t('DECLINE_ALL')))));
    };
    if (isProcessed) {
        return (React.createElement(OverlayTrigger, { placement: "bottom", overlay: TOOLTIPS.PROCESSED },
            React.createElement("span", { "data-testid": "span-1c69101c" }, renderDropdown(isShipmentCanceled(shipment) ||
                isProcessed ||
                disableBulkApprove ||
                isAnySaving))));
    }
    return renderDropdown(isShipmentCanceled(shipment) ||
        isProcessed ||
        disablePayeeResolutions ||
        isAnySaving);
};
export default BulkActionsMenu;
